<ng-container *ngIf="show">
  <div class="erp-sync-row" data-testid="erp-sync-details-status">
    <span class="erp-sync-row-label">{{ 'quotations_and_orders.erp_sync_field_label' | translate }}</span>
    <span class="erp-sync-row-value">
      <span class="erp-sync-tag" [ngStyle]="getStatusStyles()">
        <!-- A pulsing dot rather than a spinner: the sync is a wait, not a task
             the user started, and the dot borrows the tag's own ink. -->
        <span class="erp-sync-tag-pulse" *ngIf="inProgress" aria-hidden="true"></span>
        {{ 'quotations_and_orders.ErpSyncStatus.' + syncStatus | translate }}
      </span>
    </span>
  </div>

  <div class="erp-sync-row" *ngIf="isSynced && erpId" data-testid="erp-sync-details-erp-id">
    <span class="erp-sync-row-label">{{ 'quotations_and_orders.list_quotations.erp_id' | translate }}</span>
    <span class="erp-sync-row-value">
      <ui-copyable
        [value]="erpId"
        [label]="'quotations_and_orders.list_quotations.erp_id' | translate">
        {{ erpId }}
      </ui-copyable>
    </span>
  </div>
</ng-container>
